var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-location"},_vm._l((_vm.locat),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('span',[_vm._v(_vm._s(item.label))]),_c('i',{staticClass:"el-icon-arrow-right"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }